import React, { useState } from 'react'
import Card from './components/card'
import { ApplyTemplateDialog } from './components/ApplyTemplateDialog'
import Redux from 'app/interface/redux'
import Preset from 'app/interface/data/funnel/preset'
import Connect from 'app/redux/connect'
import FunnelActions from 'app/redux/actions/pages/business/funnel'
import { findUnverifiedSources, UnverifiedSource } from 'app/lib/funnel-template'

interface Pending {
  preset: Preset
  unverified: UnverifiedSource[]
}

const Presets = ({
  pages: {
    business: { funnel },
  },
  data: {
    funnel: { presets, sources },
  },
}: Redux) => {
  const [pending, setPending] = useState<Pending | null>(null)

  // Applies straight away unless that would drop a per-business source, in
  // which case the user sees exactly which ones first.
  const choose = (preset: Preset) => {
    const unverified = findUnverifiedSources(preset, sources)
    if (unverified.length === 0) {
      FunnelActions.setPreset(preset.id)
    } else {
      setPending({ preset, unverified })
    }
  }

  return (
    <div>
      <h4 style={{ color: '#575962', fontSize: '1.3rem' }}>Templates</h4>
      <div className="row mt-4">
        {presets.data.map(template => (
          <div className="col-md-3" key={template.id}>
            <Card
              active={funnel.preset === template.id}
              key={template.id}
              modify={() => choose(template)}
              {...template}
            />
          </div>
        ))}
      </div>
      {pending && (
        <ApplyTemplateDialog
          open
          templateName={pending.preset.name}
          unverified={pending.unverified}
          businessKnown={sources.businessID !== null}
          onCancel={() => setPending(null)}
          onApply={(replacements, keeps) => {
            FunnelActions.setPreset(pending.preset.id, replacements, keeps)
            setPending(null)
          }}
        />
      )}
    </div>
  )
}

export const PresetsStandalone = Presets
export default Connect(Presets)
